(function () {
    'use strict';

    angular
        .module('app.associationAdmin')
        .component('sc3AssociationMemberReport', {
            templateUrl: 'app/association-admin/association-member-report/association-member-report.component.html',
            controller: AssociationMemberReportComponent,
            bindings: {
                data: '<',                
                managementGroups: '<',
                reportFields: '<'
            }
        });

    //var noop = angular.noop,
    //    identity = angular.identity;

    AssociationMemberReportComponent.$inject = ['$scope', '$http', 'alert', 'associationAdminResources', 'DataSource', 'ManagementGroup'];
    function AssociationMemberReportComponent($scope, $http, alert, resources, DataSource, ManagementGroup) {
        var ctrl = this;  
        
        ctrl.dataSource = null;        
        ctrl.filter = { managementGroup: null, isActive: true, isPrimary: null };

        /////////////////////

        // methods
        ctrl.$onInit = init;
        ctrl.getColumnClass = getColumnClass;
        ctrl.sort = sort;


        function init() {

            ctrl.managmentGroup = 1;
            ctrl.filter.managementGroup = ctrl.managmentGroup;

            ctrl.dataSource = new DataSource({
                data: ctrl.data,
                read: getData,                
                filter: ctrl.filter,
                pageSize: 50                
            });           

            // Note: the filter change will not trigger a datasource refresh.  It has no change detection other than property setters.
            $scope.$watch('$ctrl.filter', filterWatchAction, true);
        }

        function getColumnClass(field) {
            var sort = ctrl.dataSource.sort;
            return sort && sort.field === field ? sort.dir === 'desc' ? 'sort-link-desc' : 'sort-link-asc' : null;
        }

        function sort(field) {
            var dataSource = ctrl.dataSource,
                sort = dataSource.sort;
            dataSource.sort = !sort || sort.field !== field ? { field: field, dir: 'asc' } : sort.dir === 'asc' ? { field: field, dir: 'desc' } : null;
        }

        function getData(options) {
            return ManagementGroup.getMemberReport(options, success, error);

            function success(data) {
                ctrl.data = data;
            }

            function error(rejection) {
                var isCancellation = rejection && rejection.status === -1;
                if (!isCancellation)
                    alert.error(resources.transactionLogRequestFailed);
            }
        }      

        function filterWatchAction(newVal, oldVal) {
            if (oldVal != newVal)
                ctrl.dataSource.page = 1;
        }

    }
})();